import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
    Select,
    InputLabel,
    FormControl,
    Chip,
    Box,
    OutlinedInput,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

import {
    resetGetFeeMarkupList,
    getFeeMarkupList,
} from "../../redux/actions/getFeeMarkupAction";

import {
    resetAddFeeMarkup,
    addFeeMarkup,
} from "../../redux/actions/addFeeMarkupAction";

import {
    resetUpdateFeeMarkup,
    updateFeeMarkup,
} from "../../redux/actions/updateFeeMarkupAction";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";

// ─── MUI multi-select dropdown config ────────────────────────────────────────
const ITEM_HEIGHT     = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: { maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP, width: 250 },
    },
};

const useStyles = makeStyles({
    table: { minWidth: 650 },
});

const FeeMarkup = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    /* ─── auth ───────────────────────────────────────────────────────────── */
    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const authToken = regenerateTokenRes.data.AuthToken;
    const partnerId = regenerateTokenRes.data.partnerId || "";

    const adminCurrencyList = useSelector(({ adminCurrencyList }) => adminCurrencyList);
    const currencyOptions   = adminCurrencyList.success
        ? [].concat(adminCurrencyList.data.currencyList)
        : [];

    /* ─── redux slices ───────────────────────────────────────────────────── */
    const getFeeMarkupListRes = useSelector(({ getFeeMarkupList }) => getFeeMarkupList);
    console.log("getFeeMarkupListRes",getFeeMarkupListRes)
    const addFeeMarkupRes     = useSelector(({ addFeeMarkup })     => addFeeMarkup);
    console.log("addFeeMarkupRes",addFeeMarkupRes)
    const updateFeeMarkupRes  = useSelector(({ updateFeeMarkup })  => updateFeeMarkup);
    console.log("updateFeeMarkupRes",updateFeeMarkupRes)

    /* ─── search state ───────────────────────────────────────────────────── */
    const [searchCurrency, setSearchCurrency] = useState("");

    /* ─── list state ─────────────────────────────────────────────────────── */
    const [isLoading,  setIsLoading]  = useState(false);
    const [listStatus, setListStatus] = useState(false);
    console.log("listStatus",listStatus)
    const [markupList, setMarkupList] = useState([]);
    console.log("markupList",markupList)

    /* ─── add dialog ─────────────────────────────────────────────────────── */
    const [addOpen,           setAddOpen]           = useState(false);
    const [addCurrencies,     setAddCurrencies]     = useState([]);   // string[]
    const [addConversionRate, setAddConversionRate] = useState("");
    const [addStatus,         setAddStatus]         = useState(false);

    /* ─── edit dialog ────────────────────────────────────────────────────── */
    const [editOpen,           setEditOpen]           = useState(false);
    const [editRow,            setEditRow]            = useState(null);
    const [editCurrencies,     setEditCurrencies]     = useState([]);  // string[]
    const [editConversionRate, setEditConversionRate] = useState("");
    const [editStatus,         setEditStatus]         = useState(false);

    /* ─── view dialog ────────────────────────────────────────────────────── */
    const [viewOpen, setViewOpen] = useState(false);
    const [viewRow,  setViewRow]  = useState(null);
    console.log("viewRow",viewRow)

    /* ─── notification ───────────────────────────────────────────────────── */
    const [notifOpen, setNotifOpen] = useState(false);
    const [notifData, setNotifData] = useState("");

    /* ════════════════════════════════════════════════════════════════════════
       SEARCH / LIST
    ════════════════════════════════════════════════════════════════════════ */
    const handleSearchChange = ({ target: { name, value } }) => {
        if (name === "searchCurrency") {
            setSearchCurrency(value === "Select Currency" ? "" : value);
        }
    };

    const getFeeMarkupListRequest = () => {
        setIsLoading(true);
        setListStatus(true);
        const req = {
            loginDetails: { walletOwnerId: partnerId },
            actionCustomerMasterRequestVO: { currency: searchCurrency },
        };
        return dispatch(getFeeMarkupList(req, authToken));
    };

    useEffect(() => {
        if (listStatus && getFeeMarkupListRes.data.status) {
            handleGetListResponse();
        }
    }, [getFeeMarkupListRes.data.status]);

    // const handleGetListResponse = () => {
    //     const { status, description, feeMarkupList: list } = getFeeMarkupListRes.data;
    //     if (status === "success") {
    //         setIsLoading(false);
    //         setMarkupList([].concat(list || []));
    //     }
    //     if (status === "failed" || status === "Failed") {
    //         setIsLoading(false);
    //         setListStatus(false);
    //         NotificationPopups("error", "Failed", description);
    //         if (description === "session out")          SOLogout(dispatch, authToken, partnerId);
    //         if (description === "Authorization failed") regenerateToken(dispatch, authToken, partnerId);
    //     }
    //     if (status === "Not Found") {
    //         setIsLoading(false);
    //         setListStatus(false);
    //         NotificationPopups("error", "Failed", description);
    //     }
    // };
    const handleGetListResponse = () => {
    const { status, description, transactionList } = getFeeMarkupListRes.data; // ✅ was feeMarkupList
    if (status === "success") {
        setIsLoading(false);
        // transactionList may be an object or array — normalise to array
        const list = Array.isArray(transactionList)
            ? transactionList
            : transactionList
            ? [transactionList]
            : [];
        setMarkupList(list);
        setListStatus(true); // ✅ ensure listStatus is true so table renders
    }
    if (status === "failed" || status === "Failed") {
        setIsLoading(false);
        setListStatus(false);
        NotificationPopups("error", "Failed", description);
        if (description === "session out")          SOLogout(dispatch, authToken, partnerId);
        if (description === "Authorization failed") regenerateToken(dispatch, authToken, partnerId);
    }
    if (status === "Not Found") {
        setIsLoading(false);
        setListStatus(false);
        NotificationPopups("error", "Failed", description);
    }
};

    /* ════════════════════════════════════════════════════════════════════════
       ADD
    ════════════════════════════════════════════════════════════════════════ */
    const handleAddOpen  = () => { setAddOpen(true); setAddCurrencies([]); setAddConversionRate(""); };
    const handleAddClose = () => { setAddOpen(false); };

    const handleAddCurrencyChange = ({ target: { value } }) => {
        // MUI passes the array directly for multiple Select
        setAddCurrencies(typeof value === "string" ? value.split(",") : value);
    };

    const handleAddSave = () => {
        if (addCurrencies.length === 0 || !addConversionRate) {
            NotificationPopups("error", "Validation", "Please select at least one currency and enter a conversion rate.");
            return;
        }
        setAddStatus(true);
        const req = {
            loginDetails: { walletOwnerId: partnerId },
            conversionRate: addConversionRate,
            actionCustomerMasterRequestVO: {
                currency:   addCurrencies,       // array → backend applies same rate to each
                // conversionRate: addConversionRate,
            },
        };
        dispatch(addFeeMarkup(req, authToken));
    };

    useEffect(() => {
        if (addStatus && addFeeMarkupRes.data.status) {
            handleAddResponse();
        }
    }, [addFeeMarkupRes.data.status]);

    const handleAddResponse = () => {
        const { status, description } = addFeeMarkupRes.data;
        if (status === "success") {
            setNotifData(addFeeMarkupRes.data);
            setNotifOpen(true);
            handleAddClose();
            getFeeMarkupListRequest();
            dispatch(resetAddFeeMarkup());
        }
        if (status === "failed" || status === "Failed") {
            setNotifData(addFeeMarkupRes.data);
            setNotifOpen(true);
            if (description === "session out")          SOLogout(dispatch, authToken, partnerId);
            if (description === "Authorization failed") regenerateToken(dispatch, authToken, partnerId);
        }
        setAddStatus(false);
    };

    /* ════════════════════════════════════════════════════════════════════════
       EDIT
    ════════════════════════════════════════════════════════════════════════ */
    const handleEditOpen = (row) => {
        setEditRow(row);
        // Normalise: API may return currencyList (array) or currency (string)
        setEditCurrencies(
            Array.isArray(row.currencyList) && row.currencyList.length
                ? row.currencyList
                : row.currency
                ? [row.currency]
                : []
        );
        setEditConversionRate(row.rate);
        setEditOpen(true);
    };
    const handleEditClose = () => { setEditOpen(false); setEditRow(null); };

    const handleEditCurrencyChange = ({ target: { value } }) => {
        setEditCurrencies(typeof value === "string" ? value.split(",") : value);
    };

    const handleEditSave = () => {
        if (editCurrencies.length === 0 || !editConversionRate) {
            NotificationPopups("error", "Validation", "Please select at least one currency and enter a conversion rate.");
            return;
        }
        setEditStatus(true);
        const req = {
            loginDetails: { walletOwnerId: partnerId },
             conversionRate: editConversionRate,
            actionCustomerMasterRequestVO: {
                feeMarkupId:    editRow.feeMarkupId,
                currency:   editCurrencies,
                // conversionrate: editConversionRate,
            },
        };
        dispatch(updateFeeMarkup(req, authToken));
    };

    useEffect(() => {
        if (editStatus && updateFeeMarkupRes.data.status) {
            handleEditResponse();
        }
    }, [updateFeeMarkupRes.data.status]);

    const handleEditResponse = () => {
        const { status, description } = updateFeeMarkupRes.data;
        if (status === "success") {
            setNotifData(updateFeeMarkupRes.data);
            setNotifOpen(true);
            handleEditClose();
            getFeeMarkupListRequest();
            dispatch(resetUpdateFeeMarkup());
        }
        if (status === "failed" || status === "Failed") {
            setNotifData(updateFeeMarkupRes.data);
            setNotifOpen(true);
            if (description === "session out")          SOLogout(dispatch, authToken, partnerId);
            if (description === "Authorization failed") regenerateToken(dispatch, authToken, partnerId);
        }
        setEditStatus(false);
    };

    /* ════════════════════════════════════════════════════════════════════════
       VIEW
    ════════════════════════════════════════════════════════════════════════ */
    const handleViewOpen  = (row) => { setViewRow(row); setViewOpen(true); };
    const handleViewClose = () => { setViewOpen(false); setViewRow(null); };

    // Normalise currencies from any row shape
    const getRowCurrencies = (row) =>
        Array.isArray(row.currencyList) && row.currencyList.length
            ? row.currencyList
            : row.currency
            ? [row.currency]
            : [];

    /* ════════════════════════════════════════════════════════════════════════
       NOTIFICATION CLOSE
    ════════════════════════════════════════════════════════════════════════ */
    const handleNotifClose = () => {
        setNotifOpen(false);
        setNotifData("");
        dispatch(resetAddFeeMarkup());
        dispatch(resetUpdateFeeMarkup());
    };

    /* ════════════════════════════════════════════════════════════════════════
       SHARED MULTI-SELECT COMPONENT
    ════════════════════════════════════════════════════════════════════════ */
    const MultiCurrencySelect = ({ value, onChange }) => (
        <FormControl fullWidth variant="standard">
            <InputLabel id="multi-currency-label" sx={{ color: "gray" }}>
                Currency *
            </InputLabel>
            <Select
                labelId="multi-currency-label"
                multiple
                value={value}
                onChange={onChange}
                input={<OutlinedInput sx={{ mt: 2 }} />}
                renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 0.5 }}>
                        {selected.map((val) => (
                            <Chip
                                key={val}
                                label={val}
                                size="small"
                                sx={{ backgroundColor: "#00b9f5", color: "#fff" }}
                            />
                        ))}
                    </Box>
                )}
                MenuProps={MenuProps}
                sx={{
                    "&:before": { borderBottomColor: "gray" },
                    "&:after":  { borderBottomColor: "gray" },
                    mt: 1,
                }}
            >
                {currencyOptions.map((x) => (
                    <MenuItem key={x} value={x}>{x}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );

    /* ════════════════════════════════════════════════════════════════════════
       RENDER
    ════════════════════════════════════════════════════════════════════════ */
    return (
        <>
            <Layout>
                {/* ── Search Card ── */}
                <Card>
                    <Grid
                        container
                        spacing={2}
                        alignItems="flex-end"
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        {/* Single-currency search filter */}
                        <Grid xs={12} item sm={12} md={3} lg={3}>
                            <TextField
                                select
                                size="small"
                                label="Currency"
                                variant="standard"
                                fullWidth
                                name="searchCurrency"
                                value={searchCurrency || "Select Currency"}
                                onChange={handleSearchChange}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" },
                                        "&:after":  { borderBottomColor: "gray" },
                                    },
                                }}
                                InputLabelProps={{ sx: { color: "gray" } }}
                            >
                                <MenuItem value="Select Currency">Select Currency</MenuItem>
                                {currencyOptions.map((x) => (
                                    <MenuItem key={x} value={x}>{x}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {/* Spacer */}
                        <Grid xs={12} item sm={12} md={6} lg={6} />

                        {/* Add button — top-right */}
                        <Grid
                            xs={12} item sm={12} md={3} lg={3}
                            style={{ display: "flex", justifyContent: "flex-end" }}
                        >
                            <CustomButton style={{ padding: "8px" }} onClick={handleAddOpen}>
                                Add 
                            </CustomButton>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        style={{ padding: "10px", marginTop: "1.5rem", marginBottom: "15px" }}
                    >
                        <Grid item md={5}>
                            <CustomButton style={{ padding: "8px" }} onClick={getFeeMarkupListRequest}>
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {/* ── Results Card ── */}
                {isLoading ? (
                    <LoadingSpinner />
                ) : markupList.length === 0 || !listStatus ? (
                    <Card>
                        <Grid container style={{ padding: "10px" }}>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }} className="themeText">
                                    Fee Markup List
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert className="my-3 tableHeaderColor" variant="secondary">
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid container style={{ padding: "10px" }}>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }} className="themeText">
                                    Fee Markup List
                                </Typography>
                            </Grid>

                            <TableContainer component={Paper} className="my-3">
                                <Table className={classes.table} size="small" aria-label="fee markup table">
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">
                                            {["Sr No", "Currency", "Conversion Rate", "Edit", "View"].map((col) => (
                                                <TableCell
                                                    key={col}
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {col}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {markupList.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="center">{index + 1}</TableCell>

                                                {/* Currency — chips for multi, plain text for single */}
                                                <TableCell align="center">
                                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, justifyContent: "center" }}>
                                                        {getRowCurrencies(row).map((c) => (
                                                            <Chip
                                                                key={c}
                                                                label={c}
                                                                size="small"
                                                                sx={{ backgroundColor: "#00b9f5", color: "#fff" }}
                                                            />
                                                        ))}
                                                    </Box>
                                                </TableCell>

                                                <TableCell align="center">{row.rate}</TableCell>

                                                {/* Edit */}
                                                <TableCell align="center">
                                                    <Tooltip title="Edit">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleEditOpen(row)}
                                                            style={{ color: "#00b9f5" }}
                                                        >
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>

                                                {/* View */}
                                                <TableCell align="center">
                                                    <Tooltip title="View">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleViewOpen(row)}
                                                            style={{ color: "#00b9f5" }}
                                                        >
                                                            <VisibilityIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Card>
                )}
            </Layout>

            {/* ═══════════════════════ ADD DIALOG ═════════════════════════ */}
            <Dialog open={addOpen} onClose={handleAddClose} fullWidth maxWidth="xs">
                <DialogTitle>
                    Add Fee Markup
                    <IconButton
                        onClick={handleAddClose}
                        style={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <MultiCurrencySelect
                                value={addCurrencies}
                                onChange={handleAddCurrencyChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Conversion Rate *"
                                variant="standard"
                                fullWidth
                                type="text"
                                value={addConversionRate}
                                onChange={({ target: { value } }) => {
                                    const reg = /^[0-9.]{0,10}$/;
                                    if (reg.test(value)) setAddConversionRate(value);
                                }}
                                placeholder="e.g. 1.25"
                                InputLabelProps={{ sx: { color: "gray" } }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ justifyContent: "center", padding: "12px" }}>
                    <CustomButton style={{ padding: "8px" }} onClick={handleAddSave}>
                        Save <SaveIcon style={{ marginLeft: "4px" }} />
                    </CustomButton>
                </DialogActions>
            </Dialog>

            {/* ═══════════════════════ EDIT DIALOG ════════════════════════ */}
            <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="xs">
                <DialogTitle>
                    Edit Fee Markup
                    <IconButton
                        onClick={handleEditClose}
                        style={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <MultiCurrencySelect
                                value={editCurrencies}
                                onChange={handleEditCurrencyChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Conversion Rate *"
                                variant="standard"
                                fullWidth
                                type="text"
                                value={editConversionRate}
                                onChange={({ target: { value } }) => {
                                    const reg = /^[0-9.]{0,10}$/;
                                    if (reg.test(value)) setEditConversionRate(value);
                                }}
                                InputLabelProps={{ sx: { color: "gray" } }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ justifyContent: "center", padding: "12px" }}>
                    <CustomButton style={{ padding: "8px" }} onClick={handleEditSave}>
                        Save <SaveIcon style={{ marginLeft: "4px" }} />
                    </CustomButton>
                </DialogActions>
            </Dialog>

            {/* ═══════════════════════ VIEW DIALOG ════════════════════════ */}
            <Dialog open={viewOpen} onClose={handleViewClose} fullWidth maxWidth="xs">
                <DialogTitle>
                    View Fee Markup
                    <IconButton
                        onClick={handleViewClose}
                        style={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    {viewRow && (
                        <Grid container spacing={2}>
                            {/* All selected currencies as chips */}
                            <Grid item xs={12}>
                                <Typography variant="caption" color="textSecondary">
                                    Currency
                                </Typography>
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 0.5 }}>
                                    {getRowCurrencies(viewRow).map((c) => (
                                        <Chip
                                            key={c}
                                            label={c}
                                            size="small"
                                            sx={{ backgroundColor: "#00b9f5", color: "#fff" }}
                                        />
                                    ))}
                                </Box>
                            </Grid>

                            <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary">Conversion Rate</Typography>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>
                                    {viewRow.rate}
                                </Typography>
                            </Grid>

                            {viewRow.feeMarkupId && (
                                <Grid item xs={6}>
                                    <Typography variant="caption" color="textSecondary">Fee Markup ID</Typography>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                                        {viewRow.feeMarkupId}
                                    </Typography>
                                </Grid>
                            )}

                            {viewRow.createdDate && (
                                <Grid item xs={6}>
                                    <Typography variant="caption" color="textSecondary">Created Date</Typography>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                                        {viewRow.createdDate}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    )}
                </DialogContent>

                <DialogActions style={{ justifyContent: "center", padding: "12px" }}>
                    <CustomButton style={{ padding: "8px" }} onClick={handleViewClose}>
                        Close
                    </CustomButton>
                </DialogActions>
            </Dialog>

            {/* ══════════════ SUCCESS / FAILED NOTIFICATION ═══════════════ */}
            {(notifData.status === "success" ||
              notifData.status === "failed"  ||
              notifData.status === "Failed") && (
                <Dialog open={notifOpen} onClose={handleNotifClose}>
                    <DialogContent
                        className="text-center"
                        style={{ backgroundColor: "#00b9f51c" }}
                    >
                        <img
                            src={notifData.status === "success" ? success : failed}
                            alt=""
                            width="100px"
                            className="my-2"
                        />
                    </DialogContent>
                    <DialogContent>
                        <h4 style={{ margin: "0", textAlign: "center", fontSize: "15px" }}>
                            {notifData.description}
                        </h4>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: "center" }}>
                        <CustomButton style={{ padding: "8px" }} onClick={handleNotifClose}>
                            Ok
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
};

export default FeeMarkup;